//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

import { hasFeature } from 'app/initialization/routing/stateHelpers';

// TODO: PD-267190 remove feature flag
export const getIsVibePaymentsEnabled = createHasFeatureSelector(
  FeatureNames.VibePayments,
);

export const hasFeatureVibePayments = () =>
  hasFeature(FeatureNames.VibePayments);
